module.exports = __webpack_public_path__ + "static/img/honor_2.f45a837.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_2.jpg
// module id = 8J+6
// module chunks = 0